import React from 'react';
// @ts-ignore
import { Heading, Link } from 'arag-ui-lib';
import { useHistory } from 'react-router-dom';
import i18n from '../../i18n/i18n';

type Props = {
    claimApplication: {
        claimReference: string;
        id: string;
    };
    onClaimList?: () => any;
};
const SubmittedClaim = (props: Props): JSX.Element | null => {
    const { claimApplication } = props;
    const history = useHistory();

    if (!claimApplication) {
        return null;
    }
    return (
        <React.Fragment>
            <Heading variant="h2" title={i18n.t('claimSubmittedTitle')} />
            <div className="row">
                <div className="col-sm-12">
                    {i18n.t('claimSubmittedMessageLine1') as string}
                    <Link
                        onClick={() =>
                            history.replace(`/claims/${claimApplication?.id}`)
                        }
                        variant="tertiary"
                        label={claimApplication?.claimReference || ''}
                    />
                    {i18n.t('claimSubmittedMessageLine2') as string}
                </div>
            </div>

            {/*{claimApplication &&*/}
            {/*<React.Fragment>*/}
            {/*    <FormGroup*/}
            {/*        labelSize={'col-sm-1'}*/}
            {/*        inputSize={'col-sm-11'}*/}
            {/*        label={'Type:'}*/}
            {/*        variant={'plain'}*/}
            {/*        inputProps={{*/}
            {/*            label: `${claimApplication.policyTypeName ?*/}
            {/*                claimApplication.policyTypeName  : ''} - */}
            {/*            ${claimApplication.claimCategoryName ?*/}
            {/*                claimApplication.claimCategoryName + ' - ' : ''}*/}
            {/*            ${claimApplication.claimTypeName ?*/}
            {/*                claimApplication.claimTypeName : ''}`,*/}
            {/*        }}*/}
            {/*    />*/}
            {/*    <FormGroup*/}
            {/*        labelSize={'col-sm-1'}*/}
            {/*        inputSize={'col-sm-11'}*/}
            {/*        label={'Status:'}*/}
            {/*        variant={'plain'}*/}
            {/*        inputProps={{*/}
            {/*            label: claimApplication.claimStatusName,*/}
            {/*        }}*/}
            {/*    />*/}
            {/*    <FormGroup*/}
            {/*        labelSize={'col-sm-1'}*/}
            {/*        inputSize={'col-sm-11'}*/}
            {/*        label={'Date:'}*/}
            {/*        variant={'plain'}*/}
            {/*        inputProps={{*/}
            {/*            label: moment(claimApplication.createdDate).format('DD/MM/YYYY'),*/}
            {/*        }}*/}
            {/*    />*/}
            {/*    <Button*/}
            {/*        variant={'primary'}*/}
            {/*        label={'See All You Claims'}*/}
            {/*        arrowDirection={'left'}*/}
            {/*        onClick={onClaimList}*/}
            {/*    />*/}
            {/*</React.Fragment>*/}
            {/*}*/}
        </React.Fragment>
    );
};

export default SubmittedClaim;
